import React from 'react';
import ReactDOM from 'react-dom';
// 2 บรรทัดนี้ต้องมาก่อน App: แต่ละหน้าโหลดแยกไฟล์ (lazy) แล้ว ค่าทั้งเว็บกับลำดับ CSS จึงต้องตั้งตั้งแต่เปิดเว็บ
import './static/globalSetup';
import './static/globalStyles';
import App from './app';
import * as serviceWorker from './serviceWorker';
import 'antd/dist/antd.css';
import './styles/index';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import bsCustomFileInput from 'bs-custom-file-input';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
